import React, {Component} from "react";
import {request} from "../../../api-client";
import FormViewContainer from "../../../components/Letflow/ViewContainer/FormViewContainer";
import FormContent from "../FormContent";
import localization from "../../../config/localization";
import {getUpdateFormImageUrlFromItem} from "../../../utils";
import GlobalSnackbar, {GlobalSnackbarTypes} from "../../../components/Letflow/Snackbar/GlobalSnackbar";
import {stateToHTML} from "draft-js-export-html";
import {EditorState, convertToRaw} from "draft-js";

export default class extends Component {

  state = {
    nameEs: "",
    nameEn: "",
    namePt: "",
    email: '',
    phone: '',
    descriptionEs: new EditorState.createEmpty(),
    descriptionEn: new EditorState.createEmpty(),
    descriptionPt: new EditorState.createEmpty(),
    image: { src: null, file: null },
    coverImage: { src: null, file: null },
    selectedTags: [],
    tagGroups: [],
    country: '',
    residence: '',
    active: "1",
    contentCreatorTypes: [],
    selectedContentCreatorType: '',
    socialLinks: [],
    weight: 0,
    disableForm: false,
    unsplashCoverImage: '',
    unsplashProfileImage: '',
    coverImageRadio: 'filepond',
    profileImageRadio: 'filepond',
    startActivity: null,
    countryIsCompleted: true,
    downloadableMaterialFileType: '',
    downloadableMaterialId: '',
    downloadableMaterialText: '',
    onlyArgentina: "false",
    releaseDate: null,
    expireDate: null,
    hasExpiredDate: false,
    isPermanentContent: "1",
    downloadableMaterialRadio: 'filepond',
    downloadableMaterialLink: '',
    showHelper: false,
    hasSuggestedCarousel: false,
    suggestedCarouselRadio: null,
    suggestedCarouselPlaylist: null,
    authorEn: "",
    authorEs: "",
    authorPt: "",
    categoryEn: "",
    categoryEs: "",
    categoryPt: "",
    metadata: "",
    synopsisEn: "",
    synopsisEs: "",
    synopsisPt: "",
    profileUrl: "",
  };

  requestContentCreatorCreation = () => {
    const {
      nameEs,
      nameEn,
      namePt,
      email,
      phone,
      descriptionEn,
      descriptionEs,
      descriptionPt,
      categoryEn,
      categoryEs,
      categoryPt,
      authorEn,
      authorEs,
      authorPt,
      imageId,
      coverImageId,
      selectedTags,
      country,
      residence,
      active,
      selectedContentCreatorType,
      socialLinks,
      weight,
      unsplashCoverImage,
      unsplashProfileImage,
      startActivity,
      downloadableMaterialId,
      downloadableMaterialFileType,
      downloadableMaterialText,
      onlyArgentina,
      releaseDate,
      expireDate,
      downloadableMaterialLink,
      hasSuggestedCarousel,
      suggestedCarouselPlaylist,
      metadata,
      synopsisEn,
      synopsisEs,
      synopsisPt,
      profileUrl,
    } = this.state;

    const contentCreatorData = {
      email,
      phone,
      translations: [
        {
          language: 'es',
          description: descriptionEs &&
            (selectedContentCreatorType.type === 'editorial' ?
              JSON.stringify(convertToRaw(descriptionEs.getCurrentContent())) : stateToHTML(descriptionEs.getCurrentContent())),
          name: nameEs,
          additions: `${authorEs};${categoryEs}`,
          metadata: metadata,
          synopsis: synopsisEs,
        },
        {
          language: 'en',
          description: descriptionEn &&
            (selectedContentCreatorType.type === 'editorial' ?
              JSON.stringify(convertToRaw(descriptionEn.getCurrentContent())) : stateToHTML(descriptionEn.getCurrentContent())),
          name: nameEn,
          additions: `${authorEn};${categoryEn}`,
          metadata: metadata,
          synopsis: synopsisEn,
        },
        {
          language: 'pt',
          description: descriptionPt &&
            (selectedContentCreatorType.type === 'editorial' ?
              JSON.stringify(convertToRaw(descriptionPt.getCurrentContent())) : stateToHTML(descriptionPt.getCurrentContent())),
          name: namePt,
          additions: `${authorPt};${categoryPt}`,
          metadata: metadata,
          synopsis: synopsisPt,
        },
      ],
      imageId,
      coverImageId,
      selectedTags,
      countryId: country.value,
      residenceId: residence ? residence.value : country.value,
      active,
      contentCreatorTypeId: selectedContentCreatorType.value,
      socialLinks,
      weight,
      unsplashCoverImage,
      unsplashProfileImage,
      startActivity,
      downloadableMaterialId,
      downloadableMaterialFileType,
      downloadableMaterialText,
      onlyArgentina: onlyArgentina,
      releaseDate: releaseDate,
      expireDate: expireDate,
      downloadableMaterialLink,
      hasSuggestedCarousel,
      suggestedCarouselPlaylist: suggestedCarouselPlaylist && suggestedCarouselPlaylist.value,
      profileUrl,
    };

    return request.contentCreator.create(contentCreatorData)
      .then(() => this.props.history.goBack())
  };

  requestTags = (contentCreatorType) => request.tagGroup.getAll({filterBy: [
      { column: 'type', filter: contentCreatorType.slug},
      { column: 'target_brand', filter: contentCreatorType.brand},
      { column: 'target_type', filter: this.props.location.pathname.includes('talents') ? "talent" : this.props.location.pathname.includes('audiovisual') ? 'audiovisual' : "editorial"},
      { column: 'creation', filter: 0 },
      { column: 'creation_group', filter: '0'},
      { column: 'dashboard', filter: '1'},
    ]}).then((tagGroups) => this.setState({tagGroups}))

  onChange = e => this.setState({ [e.target.id]: e.target.value });

  onImageChange = image => image ? this.setState({imageId: image.id, image: {src: null, filename: null }, imagePreview: this.formNewUrl(image.path)}) : this.setState({imageId: null, image: { src: null, filename: null }})
  onCoverImageChange = coverImage => coverImage ? this.setState({coverImageId: coverImage.id, coverImage: {src: null, filename: null }, imagePreview: this.formNewUrl(coverImage.path)}) : this.setState({coverImageId: null, coverImage: { src: null, filename: null }})
  onSetCoverImageFromUnsplash = (url, name) => this.setState({unsplashCoverImage: {url, name}})
  onSetProfileImageFromUnsplash = (url, name) => this.setState({unsplashProfileImage: {url, name}})
  onDownloadableMaterialChange = downloadableMaterial => this.setState({downloadableMaterialId: downloadableMaterial ? downloadableMaterial.id : null})

  onImageRadiosChange = (e) => {
    this.setState({[e.target.name]: e.target.value})
    if (e.target.name === 'coverImageRadio') {
        this.setState({
          imageId: '',
          image: {src: null, filename: null },
          unsplashCoverImage: '',
        })
    }
    if (e.target.name === 'profileImageRadio') {
        this.setState({
          profileId: '',
          image: {src: null, filename: null },
          unsplashProfileImage: '',
        })
    }
    if (e.target.name === 'downloadableMaterialRadio') {
      this.setState({
        downloadableMaterialId: '',
        downloadableMaterialLink: '',
      })
    }
    if (e.target.name === 'suggestedCarouselRadio') {
      this.setState({suggestedCarouselPlaylist: null})
    }
  }

  onAsyncCountriesChange = country => this.setState({ country , countryIsCompleted: true});
  onResidenceChange = residence => this.setState({residence});

  onSelectedTagsChanged = selectedTags => this.setState({ selectedTags, tagGroups: this.updateTagGroups(this.state.tagGroups, selectedTags) })

  onSelectedContentCreatorTypeChange = (selectedContentCreatorType) => {
    this.setState({selectedContentCreatorType: ''},
      () => this.setState({selectedContentCreatorType},
        () => this.requestTags(selectedContentCreatorType && selectedContentCreatorType)))
  }

  formNewUrl = (path) => {
    return process.env.REACT_APP_CDN_HOST.concat('/' + path)
  }

  setPreview = (type) => {
    if (type === 'video') {
      this.setState({video: { src: this.state.videoPreview, filename: null}})
    } else if (type === 'image') {
      let item = {image: {id: this.state.imageId, src: this.state.imagePreview}}
      this.setState({image : {src: getUpdateFormImageUrlFromItem(item)}})
    }
  }

  updateTagGroups = (tagGroups, selectedTags) => {
    return tagGroups.map(tagGroup => ({
      ...tagGroup,
      tags: tagGroup.tags.map(tag => ({
        ...tag,
        state: selectedTags.find(selectedTag => selectedTag.toString() === tag.id.toString()) ? 'selected' : 'available'
      }))
    }))
  };

  onSubmitValidation = () => {
    if (!this.state.country && this.props.location.pathname.includes('talents')) {
      GlobalSnackbar.show({message: localization.get('form.country_is_required'), type: GlobalSnackbarTypes.ERROR});
      this.setState({countryIsCompleted: false})
      return false
    } else if (!!this.state.releaseDate && !!this.state.expireDate && this.state.releaseDate > this.state.expireDate) {
      GlobalSnackbar.show({type: GlobalSnackbarTypes.ERROR, message: localization.get('form.content_creator.dates_validation')})
      return false
    } else if (this.state.synopsisEs && this.state.synopsisEs.length > 250) {
      GlobalSnackbar.show({type: GlobalSnackbarTypes.ERROR, message: localization.get('form.content_creator.synopsisEs_validation')})
      return false;
    } else if (this.state.synopsisEn && this.state.synopsisEn.length > 250) {
      GlobalSnackbar.show({type: GlobalSnackbarTypes.ERROR, message: localization.get('form.content_creator.synopsisEn_validation')})
      return false;
    } else {
      this.setState({countryIsCompleted: true})
      return true
    }
  }

  inputRef = (ref) => this.setState({inputRef: ref})


  render = () => {
    return (
      <div>
        <FormViewContainer
          title={localization.get('view.content_creator.create')}
          submitRequest={() => this.requestContentCreatorCreation()}
          onBack={() => this.props.history.goBack()}
          onRequestingStateChanged={value => this.setState({ disabled: value })}
          hasTranslatableInputs
          disabled={this.state.disableForm}
          validation={this.onSubmitValidation}
        >
          <FormContent
            nameEs={this.state.nameEs}
            nameEn={this.state.nameEn}
            namePt={this.state.namePt}
            email={this.state.email}
            phone={this.state.phone}
            descriptionEn={this.state.descriptionEn}
            descriptionEs={this.state.descriptionEs}
            descriptionPt={this.state.descriptionPt}
            authorEn={this.state.authorEn}
            authorEs={this.state.authorEs}
            authorPt={this.state.authorPt}
            categoryEn={this.state.categoryEn}
            categoryEs={this.state.categoryEs}
            categoryPt={this.state.categoryPt}
            synopsisEn={this.state.synopsisEn}
            synopsisEs={this.state.synopsisEs}
            synopsisPt={this.state.synopsisPt}
            image={this.state.image}
            onChange={this.onChange}
            onImageChange={this.onImageChange}
            tagGroups={this.state.tagGroups}
            onSelectedTagsChanged={this.onSelectedTagsChanged}
            country={this.state.country}
            onAsyncCountriesChange={this.onAsyncCountriesChange}
            residence={this.state.residence}
            onResidenceChange={this.onResidenceChange}
            active={this.state.active}
            onActiveChange={(active) => this.setState({active}, () => this.state.active && this.setState({releaseDate: null, expireDate: null}))}
            selectedContentCreatorType={this.state.selectedContentCreatorType}
            socialLinks={this.state.socialLinks}
            onSocialLinksChange={socialLinks => this.setState({socialLinks})}
            onSelectedContentCreatorTypeChange={this.onSelectedContentCreatorTypeChange}
            coverImage={this.state.coverImage}
            onCoverImageChange={this.onCoverImageChange}
            weight={this.state.weight}
            updateDisableForm={value => this.setState({disableForm: value})}
            onSetPreview={this.setPreview}
            disableForm={this.state.disableForm}
            coverImageRadio={this.state.coverImageRadio}
            profileImageRadio={this.state.profileImageRadio}
            onSetCoverImageFromUnsplash={this.onSetCoverImageFromUnsplash}
            onSetProfileImageFromUnsplash={this.onSetProfileImageFromUnsplash}
            onImageRadiosChange={this.onImageRadiosChange}
            startActivity={this.state.startActivity}
            handleStartActivityChange={date => this.setState({startActivity: date})}
            countryIsCompleted={this.state.countryIsCompleted}
            isTalent={this.props.location.pathname.includes('talents')}
            isAudiovisual={this.props.location.pathname.includes('audiovisual')}
            onContentChange={(e, field) => this.setState({[field]: e})}
            onDownloadableMaterialChange={this.onDownloadableMaterialChange}
            setDownloadableMaterialFileType={downloadableMaterialFileType => this.setState({downloadableMaterialFileType})}
            downloadableMaterialText={this.state.downloadableMaterialText}
            onlyArgentina={this.state.onlyArgentina}
            releaseDate={this.state.releaseDate}
            expireDate={this.state.expireDate}
            hasExpiredDate={this.state.hasExpiredDate}
            onHasExpiredDateChange={hasExpiredDate => this.setState({hasExpiredDate}, () => this.state.hasExpiredDate && this.setState({expireDate: null}))}
            isPermanentContent={this.state.isPermanentContent}
            onIsPermanentContentChange={isPermanentContent => this.setState({isPermanentContent}, () => !this.state.isPermanentContent && this.setState({expireDate: null, releaseDate: null}))}
            downloadableMaterialRadio={this.state.downloadableMaterialRadio}
            downloadableMaterialLink={this.state.downloadableMaterialLink}
            showHelper={this.state.showHelper}
            updateHelper={() => this.setState({showHelper: !this.state.showHelper})}
            hasSuggestedCarousel={this.state.hasSuggestedCarousel}
            onSuggestedCarouselChange={hasSuggestedCarousel => this.setState({hasSuggestedCarousel, suggestedCarouselPlaylist: null})}
            suggestedCarouselRadio={this.state.suggestedCarouselRadio}
            onSuggestedCarouselPlaylistChange={suggestedCarouselPlaylist => this.setState({suggestedCarouselPlaylist})}
            suggestedCarouselPlaylist={this.state.suggestedCarouselPlaylist}
            metadata={this.state.metadata}
            profileUrl={this.state.profileUrl}
          />
        </FormViewContainer>
      </div>
    )
  }
}
